// Сервис для работы с аудио сообщениями через API
class AudioMessageService {
  constructor(axiosInstance) {
    this.axios = axiosInstance;
    this.baseURL = "/audio-message";
  }

  /**
   * Загрузить аудио на сервер
   * @param {Blob} audioBlob - Аудио blob
   * @param {number} duration - Длительность в секундах
   * @returns {Promise<{audioId: string, size: number, duration: number}>}
   */
  async uploadAudio(audioBlob, duration = 0) {
    const uploadStartTime = Date.now();
    try {
      console.log("📤 [AudioService] ========== НАЧАЛО ЗАГРУЗКИ ==========");
      console.log("📤 [AudioService] Размер blob:", audioBlob.size, "байт");
      console.log("📤 [AudioService] Тип:", audioBlob.type);
      console.log("📤 [AudioService] Длительность:", duration, "сек");
      console.log("📤 [AudioService] Endpoint:", `${this.baseURL}/upload`);

      const formData = new FormData();
      formData.append("audio", audioBlob, "audio.webm");
      formData.append("duration", duration.toString());

      console.log("📤 [AudioService] Отправка запроса...");
      const response = await this.axios.post(
        `${this.baseURL}/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const uploadDuration = Date.now() - uploadStartTime;
      console.log("✅ [AudioService] ========== ЗАГРУЗКА УСПЕШНА ==========");
      console.log("✅ [AudioService] Время загрузки:", uploadDuration, "мс");
      console.log("✅ [AudioService] Ответ сервера:", response.data);

      return response.data;
    } catch (error) {
      const uploadDuration = Date.now() - uploadStartTime;
      console.error("❌ [AudioService] ========== ОШИБКА ЗАГРУЗКИ ==========");
      console.error("❌ [AudioService] Время до ошибки:", uploadDuration, "мс");
      console.error("❌ [AudioService] Ошибка:", error);
      console.error("❌ [AudioService] Ответ сервера:", error.response?.data);
      throw error;
    }
  }

  /**
   * Получить URL для воспроизведения аудио
   * @param {string} audioId - ID аудио на сервере
   * @returns {string} URL для воспроизведения
   */
  getAudioURL(audioId) {
    // Пытаемся получить токен из authState
    let token = null;
    const authState = localStorage.getItem("authState");
    if (authState) {
      try {
        const parsed = JSON.parse(authState);
        token = parsed.auth_token;
      } catch (e) {
        console.error("Ошибка парсинга authState:", e);
      }
    }

    // Fallback на прямой токен
    if (!token) {
      token = localStorage.getItem("token");
    }

    const baseURL = "https://api.mytadating.site/api";
    const url = `${baseURL}${this.baseURL}/get/${audioId}`;

    console.log("🔗 Создаем URL для аудио:", audioId);
    console.log("🔑 Токен найден:", !!token);

    // Добавляем токен в URL для авторизации
    if (token) {
      return `${url}?token=${encodeURIComponent(token)}`;
    }

    return url;
  }

  /**
   * Удалить аудио с сервера
   * @param {string} audioId - ID аудио на сервере
   * @returns {Promise<void>}
   */
  async deleteAudio(audioId) {
    try {
      console.log("🗑️ Удаляем аудио с сервера:", audioId);

      await this.axios.delete(`${this.baseURL}/delete/${audioId}`);

      console.log("✅ Аудио удалено с сервера");
    } catch (error) {
      console.error("❌ Ошибка удаления аудио:", error);
      throw error;
    }
  }

  /**
   * Получить аудио как Blob для воспроизведения
   * @param {string} audioId - ID аудио на сервере
   * @returns {Promise<string>} Blob URL для воспроизведения
   */
  async getAudioAsBlob(audioId) {
    try {
      console.log("📥 [getAudioAsBlob] Загружаем аудио как blob:", audioId);

      const response = await this.axios.get(`${this.baseURL}/get/${audioId}`, {
        responseType: "blob",
      });

      console.log("✅ [getAudioAsBlob] Blob получен");
      console.log("✅ [getAudioAsBlob] Размер:", response.data.size);
      console.log("✅ [getAudioAsBlob] Тип:", response.data.type);

      const blobUrl = URL.createObjectURL(response.data);
      console.log("✅ [getAudioAsBlob] Blob URL создан:", blobUrl);

      return blobUrl;
    } catch (error) {
      console.error("❌ [getAudioAsBlob] Ошибка:", error);
      throw error;
    }
  }

  /**
   * Получить статус временных аудио
   * @returns {Promise<{count: number, audios: Array}>}
   */
  async getStatus() {
    try {
      const response = await this.axios.get(`${this.baseURL}/status`);
      return response.data;
    } catch (error) {
      console.error("❌ Ошибка получения статуса:", error);
      throw error;
    }
  }

  /**
   * Создать объект Audio для воспроизведения
   * @param {string} audioId - ID аудио на сервере
   * @returns {Promise<HTMLAudioElement>}
   */
  async createAudioElement(audioId) {
    try {
      console.log("🎵 Создаем элемент Audio для:", audioId);

      // Получаем blob напрямую
      const response = await this.axios.get(`${this.baseURL}/get/${audioId}`, {
        responseType: "blob",
      });

      // Создаем URL из blob
      const audioUrl = URL.createObjectURL(response.data);

      // Создаем элемент audio
      const audio = new Audio(audioUrl);

      // Автоматически освобождаем URL после воспроизведения
      audio.addEventListener("ended", () => {
        URL.revokeObjectURL(audioUrl);
      });

      // Освобождаем URL при ошибке
      audio.addEventListener("error", () => {
        URL.revokeObjectURL(audioUrl);
      });

      console.log("✅ Audio элемент создан");
      return audio;
    } catch (error) {
      console.error("❌ Ошибка создания Audio элемента:", error);
      throw error;
    }
  }
}

export default AudioMessageService;
